<script lang="ts">
    import { base } from '$app/paths';
</script>

<a href="{base}/" class="logo-container" aria-label="1312 Supreme">
    <img src="/favicon.png" alt="1312 Logo" class="brand-image" />
</a>

<style>
    .logo-container {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 18px 0;
        text-decoration: none;
        outline: none;
        -webkit-tap-highlight-color: transparent;
    }

    .brand-image {
        height: 40px; /* Tamaño perfecto y contenido para la sidebar */
        width: auto;
        object-fit: contain;
        transition: transform 0.2s ease;
    }

    .logo-container:active .brand-image {
        transform: scale(0.95);
    }
    
    @media screen and (max-width: 535px) {
        .logo-container {
            display: none; /* Se oculta en móviles para no estorbar */
        }
    }
</style>